<template>
  <div v-if="loading" class="page-loading">
    <Loading />
  </div>
  <div>
    <main class="forgot-password-page">
			<div class="properties-menu">
				<PropertiesComponent />
			</div>
      <div class="container">
        <div class="forgot-password-card">
          <div class="card-header">
            <img src="@/assets/img/logo/logo.jpeg" alt="Company Logo" class="logo" />
            <h1>{{ $t('ForgotPassword.name') }}</h1>
            <p>{{ $t('ForgotPassword.enterYourEmailAddressToAccessYourAccount') }}.</p>
          </div>
          <form @submit.prevent="handleForgotPassword" class="email-form">
            <div class="form-group">
              <label for="email">{{ $t('ForgotPassword.email') }}</label>
              <div class="input-wrapper">
                <input
                  type="email"
                  id="email"
                  v-model="email"
                  required
                  placeholder="E-posta adresinizi girin"
                  @input="validateEmail"
                />
                <span class="material-symbols-outlined input-icon">
                  mail
                </span>
              </div>
            </div>

            <!-- Gönder Butonu -->
            <button type="submit" class="submit-button">
              <span>{{ $t('ForgotPassword.sendEmail') }}</span>
            </button>
          </form>

          <!-- Giriş Sayfasına Bağlantı -->
          <div class="login-link">
            {{ $t('ForgotPassword.alreadyHaveAccount') }} <router-link to="/login">{{ $t('ForgotPassword.signIn') }}</router-link>
          </div>
        </div>
      </div>
    </main>
  </div>

  <!-- Bildirim Bileşeni -->
  <NotificationComponent
    v-if="notification.show"
    :key="notification.key"
    :type="notification.type"
    :title="notification.title"
    :message="notification.message"
    :duration="2000"
    @closed="!notification.show"
  />
</template>
<script>
import Loading from "@/components/user/layout/LoadingComponent.vue";
import NotificationComponent from "@/components/custom/notifications/NotificationComponent.vue";
import { handleForgotPassword } from "@/api/auth.api";
import PropertiesComponent from '@/components/user/layout/PropertiesComponent.vue';

export default {
  name: "ForgotPassword",
  components: {
    Loading,
    NotificationComponent,
    PropertiesComponent,
  },
  data() {
    return {
      notification: {
        show: false,
        key: 0,
        type: "",
        title: "",
        message: "",
      },
      isLoading: false,
      errorMessage: "",
      successMessage: "",
      loading: false,
      email: '',
    };
  },
  methods: {
    async handleForgotPassword() {
      this.loading = true;
      try {
        const response = await handleForgotPassword(this.email);
        if (response.data.status) {
          this.showNotification(
            "success",
            this.$t("Custom.success"),
            this.$t(response.data.msg)
          );
        } else {
          this.showNotification(
            "error",
            this.$t("Custom.error"),
            this.$t(response.data.msg)
          );
        }
      } catch (error) {
        this.showNotification(
          "error",
          this.$t("Custom.error"),
          error.response.data.msg
        );
      } finally {
        this.loading = false;
      }
    },
    showNotification(type, title, message) {
      this.notification = {
        show: true,
        key: Date.now(),
        type,
        title,
        message,
      };
    },
  },
};
</script>

<style scoped>

.forgot-password-page {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 2rem;
}

.container {
  max-width: 480px;
  width: 100%;
  animation: slideUp 0.6s ease;
  font-family: "Quicksand", sans-serif;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Kart Tasarımı Güncellemesi */
.forgot-password-card {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  padding: 2.5rem;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.card-header {
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.card-header .logo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 100px;
  object-fit: contain;
  border-radius: 25%;
  margin-bottom: 1.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.card-header h1 {
  font-size: 1.8rem;
  color: #1a1a1a;
  margin-bottom: 0.5rem;
  letter-spacing: -0.5px;
}

.card-header p {
  font-size: 0.95rem;
  color: #666;
  line-height: 1.5;
}

/* Form Elementleri İyileştirmeleri */
.email-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.input-wrapper {
  position: relative;
  transition: all 0.3s ease;
}

.input-wrapper input {
  width: 100%;
  margin-top: 5px;
  padding: 0.875rem 1rem 0.875rem 2.5rem;
  border: 2px solid #e0e0e0;
  border-radius: 10px;
  font-size: 0.95rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: #fcfcfc;
}

.input-wrapper input:focus {
  border-color: var(--logo-color);
  box-shadow: 0 0 0 3px rgba(199, 120, 2, 0.15);
  background: #fff;
}

.input-icon {
  position: absolute;
  left: 10px;
  top: 51%;
  transform: translateY(-50%);
  color: #888;
  z-index: 1;
}
/* Buton Tasarımı Güncellemesi */
.submit-button {
  width: 100%;
  padding: 0.875rem;
  background: linear-gradient(135deg, var(--logo-color) 0%, #d18a0f 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.submit-button::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    120deg,
    transparent,
    rgba(255, 255, 255, 0.3),
    transparent
  );
  transition: 0.5s;
}

.submit-button:hover::before {
  left: 100%;
}

.submit-button:hover {
  box-shadow: 0 6px 20px rgba(199, 120, 2, 0.2);
}

/* Yükleme Animasyonu */
.loading-spinner {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.spinner {
  width: 1.25rem;
  height: 1.25rem;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  animation: spin 0.8s linear infinite;
}

.login-link {
  margin-top: 1.5rem;
  font-size: 0.9rem;
  color: #666;
}

.login-link a {
  color: var(--logo-color);
  font-weight: 600;
  text-decoration: none;
  position: relative;
}

.login-link a::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 0;
  height: 2px;
  background: var(--logo-color);
  transition: width 0.3s ease;
}

.login-link a:hover::after {
  width: 100%;
}

/* Responsive Tasarım İyileştirmeleri */
@media (max-width: 640px) {
  .forgot-password-page {
    padding: 1rem;
  }

  .forgot-password-card {
    padding: 1.5rem;
  }

  .card-header h1 {
    font-size: 1.5rem;
  }

  .input-wrapper input {
    padding: 0.75rem 1rem 0.75rem 2.25rem;
  }
}

@media (max-width: 480px) {
  .card-header .logo {
    width: 80px;
    height: 80px;
  }
}
</style>